import { AlertTriangle } from "lucide-react";

export default function LegacyFormRetiredPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4" data-testid="legacy-form-retired-page">
      <div className="max-w-md text-center">
        <AlertTriangle className="mx-auto mb-3 h-10 w-10 text-slate-400" />
        <p className="text-lg font-bold text-slate-700">This form is no longer available.</p>
        <p className="mt-2 text-sm text-slate-500">Please contact the business directly or ask them for their current intake link.</p>
      </div>
    </div>
  );
}
